<template>
  <div class="home">
    <topmenu @refresh="refresh" @add="addModalShow = true"/>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column">
            <b-field label="Змінити день">
              <b-datepicker v-model="date"
                  @input="refresh"
                  :month-names="$store.state.month"
                  :indicators="'bars'"
                  :events="notDone"
                  :first-day-of-week="1"
                  placeholder="Змінити дату">

                  <button class="button is-primary"
                      @click="date = new Date()">
                      <b-icon icon="calendar-today"></b-icon>
                      <span>Сегодня</span>
                  </button>
              </b-datepicker>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Пошук по номеру картки">
              <b-input @input="searchQuery"></b-input>
            </b-field>
          </div>
        </div>
        <div class="last-day">
          <b-tabs v-model="activeTab">
            <b-tab-item label="Процес">
              <div>
                <procTable @refresh="refresh" :showFooter="true" :data="data" @showSelected="activeTab = 1" @setSelected="selected = $event"/>
              </div>

              <costs :data="waste" @refresh="getCostsHandle"/>

            </b-tab-item>

            <b-tab-item label="Інформація по картці">
              <selectedCard @removed="refreshAfterRemoved" :selected="selected" :services="services"/>
            </b-tab-item>
          </b-tabs>
        </div>
      </div>
    </section>

    <addPanel
      v-if="addModalShow"
      @refresh="refresh"
      @close="addModalShow = false"
    />

    <div class="add-fixed-button">
      <b-button type="is-info" @click="addModalShow = true" icon-left="plus" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import costs from "@/components/costs.vue";
import topmenu from "@/components/menu.vue";
import procTable from "@/components/procTable.vue";
import addPanel from "@/components/fixedBottomPanel.vue";
import selectedCard from "@/components/selectedCard.vue";
import { mapActions, mapState } from 'vuex';

export default {
  name: "home",
  data() {
    return {
      data: [],
      date: new Date(),
      waste: [],
      selected: null,
      activeTab: 0,
      addModalShow: false,
      notDone: []
    };
  },
  computed: {
    ...mapState(['services']),
    today() {
      var today = this.date;
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
      return `${yyyy}-${mm}-${dd}`
    }
  },
  methods: {
    ...mapActions(['getProcesses', 'getCosts']),
    refreshAfterRemoved() {
      this.activeTab = 0
      this.refresh()
    },
    refresh() {
      this.notDoneProcesses()
      this.getCostsHandle()
      this.getdata()
    },
    async getCostsHandle() {
      const res = await this.getCosts({
        date: this.today
      })
      this.waste = res
    },
    searchQuery(query) {
      this.getProcesses({
        params: {
          date: this.today,
          search: query
        }
      }).then((result) => {
        this.data = result
      })
    },
    getdata() {
      this.getProcesses({
        params: {
          date: this.today
        }
      }).then((result) => {
        this.data = result
      })
    },
    price(row) {
      return Number(row.weight) * Number(row.program.price)
    },
    async notDoneProcesses() {
      this.notDone = []
      await this.getProcesses({
        params: {
          not_done: true
        }
      }).then(res => {
        let obj = {}
        res.forEach(el => {
          let created_at = new Date(el.created_at)
          let date = new Date(created_at.getFullYear(), created_at.getMonth(), created_at.getDate())
          obj[date] = true
        });
        let arr = Object.keys(obj)
        arr.forEach(x => {
          this.notDone.push(new Date(x))
        })
      })
    }
  },
  components: {
    topmenu,
    costs,
    procTable,
    selectedCard,
    addPanel
  },
  mounted() {
    this.refresh()
  }
};
</script>
